// Website copy in English, French and Kinyarwanda. Keys are shared; {name}
// placeholders are filled by t(). The Kinyarwanda Bible quote on the page is
// scripture and stays untranslated.

const en = {
  lang: { label: 'Language', en: 'English', fr: 'Français', rw: 'Kinyarwanda' },
  nav: {
    home: 'Home',
    about: 'About Us',
    pilgrimages: 'Pilgrims',
    testimonials: 'Testimonials',
    contact: 'Contact Us',
    login: 'Login',
  },
  banner: {
    open: 'Now open for booking: {name} on {date}.',
    closed: 'Next pilgrimage: {name} on {date}.',
    fallback: 'Join our monthly pilgrimage on the last Sunday of every month.',
    reserve: 'Reserve a seat Now!',
    booking_closed: 'Booking closed',
  },
  hero: {
    eyebrow: 'Indabo Za Mariya',
    title: 'Welcome to Indabo Za Mariya community',
    subtitle: 'No matter where you are on your journey you are welcome to be here. Whether you are seeking for answers or looking for a community, we invite you to join us.',
    cta: 'Look for Pilgrimages',
    image_alt: 'Statue of the Virgin Mary in a blue mantle, praying with a rosary',
  },
  about: {
    eyebrow: 'About Indabo Za Mariya',
    title: 'About Us',
    intro: 'The Catholic Organisation “Indabo za Mariya Nyina wa Jambo wa Kibeho Umwamikazi w’Imitima” (Flowers of Mary Mother of the Word Queen of Hearts) was established following the inspiration received by a Christian woman during the Christmas High Mass on 25 December 2004 at Saint Michael Cathedral Parish in the Archdiocese of Kigali.',
    welcome: 'Welcome to Indabo Za Mariya',
    mission: 'Inspired by the message of Our Lady of Kibeho, the ministry was created to help Christians renew their faith, deepen their relationship with God, and live according to the teachings of the Catholic Church. The organization promotes prayer, evangelization, spiritual retreats, and monthly pilgrimages to Kibeho every last Sunday of the month.',
    photo_back_alt: 'Indabo Za Mariya members in white with blue scarves gathered outside the church',
    photo_front_alt: 'Members holding candles during Mass with the priest',
  },
  pilgrimages: {
    title: 'Upcoming Pilgrimages',
    loading: 'Loading upcoming pilgrimages…',
    closes: 'Booking closes {when}',
    closed: 'Booking closed',
    reserve: 'Reserve spot',
    opens_soon: 'Booking opens soon',
    more: 'More Pilgrimages',
    showcase: {
      kibeho: 'We provide comprehensive resources, personalized guidance, and a supportive community to deepen your spiritual experience and foster personal growth. Our mission is to empower individuals to embark on meaningful pilgrimages, discover inner peace, and connect their faith on a profound level.',
      sinai: 'Join us on a transformative journey to the peak where history and faith converge. Experience breathtaking views, ancient paths, and moments of true reflection.',
      camino: 'Walk the legendary pilgrimage route through scenic landscapes and vibrant cultures. Our expert guides ensure a safe, inspiring, and unforgettable spiritual experience.',
    },
  },
  moments: {
    eyebrow: 'Past pilgrimage',
    title: 'Our pilgrimage to Tanzania',
    tag: 'Tanzania',
    p1: 'Pilgrims of Indabo Za Mariya travelled together to Tanzania, where we were welcomed by the Indabo Za Mariya community there. Dressed in white with our blue scarves, we prayed, sang and celebrated Mass as one family under the protection of the Virgin Mary.',
    p2: 'Moments like these remind us that our faith has no borders, and that every pilgrimage brings us closer to Mary and to one another.',
    cta: 'Join our next pilgrimage',
    gallery: 'Moments from our community',
    feature_alt: 'The Indabo Za Mariya community, dressed in white with blue scarves, gathered outside a church in Tanzania',
    praise: 'Praise & worship',
    praise_alt: 'Members raising their hands in praise during Mass',
    vigil: 'Candlelight vigil',
    vigil_alt: 'Young men holding lit candles during the celebration',
    offering: 'An offering to Mary',
    offering_alt: 'A member in white holding a yellow rose',
    youth: 'Youth in prayer',
    youth_alt: 'Youth of the community praying with open hands',
  },
  testimonials: {
    eyebrow: 'Testimonials',
    title: 'How Lives are transformed through love, and faith.',
    play: 'Play testimonial video',
    poster_alt: 'Young members of the community praying during Mass',
    pages: 'Testimonials pages',
    prev: 'Previous page',
    next: 'Next page',
  },
  contact: {
    eyebrow: 'Contact Us',
    title: 'Let’s work together',
    first_name: 'First Name',
    last_name: 'Last Name',
    email: 'Email Address',
    location: 'Location',
    subject: 'Subject',
    message: 'Message',
    submit: 'Submit',
    sending: 'Sending...',
  },
  newsletter: {
    title: 'Subscribe to our newsletter',
    text: 'Subscribe to our newsletter and be the first to receive notifications updates and some recommendations to strengthen your spiritual life',
    eyebrow: 'Stay up to date',
    placeholder: 'Enter your email',
    subscribe: 'Subscribe',
    sending: 'Sending...',
    agree: 'By Subscribing you agree to our',
    terms: 'Terms and Conditions',
  },
  footer: {
    tagline: 'We are the Indabo Za Mariya community',
    features: 'Features',
    payment: 'Payment',
    card: 'Card',
    transport: 'Transport',
    security: 'Security',
    terms: 'Terms',
    conditions: 'Conditions',
    privacy: 'Privacy',
    copyright: 'Copyright © {year}',
    data_privacy: 'Data and Privacy',
  },
  booking: {
    title: 'Reserve Spot',
    sub_details: 'Enter your details and add everyone travelling with you.',
    sub_payment: 'Review the total and pay securely.',
    sub_confirm: 'Almost there — confirming your payment.',
    step_details: 'Details',
    step_payment: 'Payment',
    step_confirm: 'Confirmation',
    description: 'Description',
    important: 'Important Information',
    departure_time: 'Departure Time: {time}',
    departure_location: 'Departure Location: {place}',
    map_title: 'Pilgrimage location map',
    your_details: 'Your details',
    your_details_sub: 'You are traveller 1 and the contact for this booking.',
    first_name: 'First Name',
    last_name: 'Last Name',
    first_name_ph: 'Enter first name',
    last_name_ph: 'Enter last name',
    first_name_short_ph: 'First name',
    last_name_short_ph: 'Last name',
    phone: 'Phone',
    phone_number: 'Phone Number',
    email: 'Email',
    parish: 'Parish',
    parish_ph: 'e.g. Sainte Famille',
    gender: 'Gender',
    female: 'Female',
    male: 'Male',
    pickup: 'Pickup Location',
    optional: 'optional',
    member_self: 'I am a member of the Indabo za Mariya community',
    member_other: 'Member of the Indabo za Mariya community',
    member_tag: 'Member',
    invalid_phone: 'Enter a valid Rwandan mobile number',
    who: 'Who is travelling?',
    per_person: '{price} per person',
    add_traveller: 'Add another traveller',
    add_aria: 'Add a traveller',
    remove_aria: 'Remove a traveller',
    remove_traveller: 'Remove traveller',
    done: 'Done',
    traveller_n: 'Traveller {n}',
    details_added: 'Details added',
    details_needed: 'Details needed',
    complete_fields: 'Please complete the highlighted fields before continuing.',
    travellers: 'Travellers',
    summary: 'Summary of Charge',
    transport_line: 'Transport (round trip) × {n}',
    fee_line: 'Transaction fee × {n}',
    total: 'Total',
    people_one: '{n} person',
    people_other: '{n} people',
    payment_method: 'Mean of Payment',
    card: 'Card',
    momo_number: 'MoMo Phone Number',
    momo_note: 'You will receive a prompt on this phone to approve {amount} with your PIN.',
    card_note: 'You will be redirected to our payment partner’s secure page to enter your card details.',
    agree: 'I agree to terms and conditions for this action',
    back: 'Back',
    next: 'Next: Payment',
    processing: 'Processing…',
    pay: 'Pay {amount}',
    close: 'Close',
    reserved_title: 'Your spot is reserved!',
    reserved_text: 'Payment of {amount} received for {people} — {event}.',
    reference: 'Booking reference',
    reference_hint: 'Keep this reference; you will be asked for it when boarding.',
    failed_title: 'Payment not completed',
    failed_text: 'The payment was declined, cancelled or timed out. You have not been charged.',
    try_again: 'Try again',
    confirming_card: 'Confirming your card payment…',
    approve_phone: 'Approve the payment on your phone',
    momo_sent: 'We sent a Mobile Money request of {amount}. Enter your PIN to approve. No prompt? Dial {ussd} to see pending payments.',
    auto_update: 'This page updates automatically — please don’t close it.',
    not_found: 'We could not find this booking.',
    timeout: 'We have not received confirmation yet. If money left your account, contact us with your booking reference.',
  },
  payment_return: {
    title: 'Your reservation',
    no_reference: 'No booking reference was provided.',
    home: 'Back to home',
  },
};

const fr = {
  lang: { label: 'Langue', en: 'English', fr: 'Français', rw: 'Kinyarwanda' },
  nav: {
    home: 'Accueil',
    about: 'À propos',
    pilgrimages: 'Pèlerinages',
    testimonials: 'Témoignages',
    contact: 'Contact',
    login: 'Connexion',
  },
  banner: {
    open: 'Réservations ouvertes : {name}, le {date}.',
    closed: 'Prochain pèlerinage : {name}, le {date}.',
    fallback: 'Rejoignez notre pèlerinage mensuel, le dernier dimanche de chaque mois.',
    reserve: 'Réservez votre place !',
    booking_closed: 'Réservations fermées',
  },
  hero: {
    eyebrow: 'Indabo Za Mariya',
    title: 'Bienvenue dans la communauté Indabo Za Mariya',
    subtitle: 'Où que vous en soyez dans votre cheminement, vous êtes le bienvenu ici. Que vous cherchiez des réponses ou une communauté, nous vous invitons à nous rejoindre.',
    cta: 'Voir les pèlerinages',
    image_alt: 'Statue de la Vierge Marie au manteau bleu, priant avec un chapelet',
  },
  about: {
    eyebrow: 'À propos d’Indabo Za Mariya',
    title: 'Qui sommes-nous',
    intro: 'L’organisation catholique « Indabo za Mariya Nyina wa Jambo wa Kibeho Umwamikazi w’Imitima » (Fleurs de Marie, Mère du Verbe, Reine des Cœurs) a été fondée à la suite de l’inspiration reçue par une chrétienne lors de la grand-messe de Noël, le 25 décembre 2004, à la paroisse cathédrale Saint-Michel, dans l’archidiocèse de Kigali.',
    welcome: 'Bienvenue à Indabo Za Mariya',
    mission: 'Inspiré par le message de Notre-Dame de Kibeho, ce ministère a été créé pour aider les chrétiens à renouveler leur foi, à approfondir leur relation avec Dieu et à vivre selon les enseignements de l’Église catholique. L’organisation promeut la prière, l’évangélisation, les retraites spirituelles et les pèlerinages mensuels à Kibeho, chaque dernier dimanche du mois.',
    photo_back_alt: 'Membres d’Indabo Za Mariya en blanc avec des foulards bleus, réunis devant l’église',
    photo_front_alt: 'Membres tenant des cierges pendant la messe avec le prêtre',
  },
  pilgrimages: {
    title: 'Pèlerinages à venir',
    loading: 'Chargement des pèlerinages à venir…',
    closes: 'Réservations jusqu’au {when}',
    closed: 'Réservations fermées',
    reserve: 'Réserver une place',
    opens_soon: 'Réservations bientôt ouvertes',
    more: 'Plus de pèlerinages',
    showcase: {
      kibeho: 'Nous offrons des ressources complètes, un accompagnement personnalisé et une communauté bienveillante pour approfondir votre vie spirituelle. Notre mission est d’aider chacun à vivre des pèlerinages porteurs de sens, à trouver la paix intérieure et à vivre sa foi en profondeur.',
      sinai: 'Rejoignez-nous pour un voyage transformateur vers le sommet où l’histoire et la foi se rencontrent. Des panoramas à couper le souffle, des chemins anciens et de vrais moments de recueillement.',
      camino: 'Marchez sur la légendaire route de pèlerinage, à travers des paysages magnifiques et des cultures vivantes. Nos guides expérimentés vous assurent une expérience spirituelle sûre, inspirante et inoubliable.',
    },
  },
  moments: {
    eyebrow: 'Pèlerinage passé',
    title: 'Notre pèlerinage en Tanzanie',
    tag: 'Tanzanie',
    p1: 'Les pèlerins d’Indabo Za Mariya ont voyagé ensemble en Tanzanie, où nous avons été accueillis par la communauté Indabo Za Mariya locale. Vêtus de blanc avec nos foulards bleus, nous avons prié, chanté et célébré la messe comme une seule famille, sous la protection de la Vierge Marie.',
    p2: 'Ces moments nous rappellent que notre foi n’a pas de frontières et que chaque pèlerinage nous rapproche de Marie et les uns des autres.',
    cta: 'Rejoignez notre prochain pèlerinage',
    gallery: 'Moments de notre communauté',
    feature_alt: 'La communauté Indabo Za Mariya, vêtue de blanc avec des foulards bleus, réunie devant une église en Tanzanie',
    praise: 'Louange et adoration',
    praise_alt: 'Membres levant les mains en louange pendant la messe',
    vigil: 'Veillée aux cierges',
    vigil_alt: 'Jeunes hommes tenant des cierges allumés pendant la célébration',
    offering: 'Une offrande à Marie',
    offering_alt: 'Une membre en blanc tenant une rose jaune',
    youth: 'Jeunes en prière',
    youth_alt: 'Les jeunes de la communauté priant les mains ouvertes',
  },
  testimonials: {
    eyebrow: 'Témoignages',
    title: 'Comment des vies sont transformées par l’amour et la foi.',
    play: 'Lire la vidéo de témoignage',
    poster_alt: 'Jeunes membres de la communauté priant pendant la messe',
    pages: 'Pages des témoignages',
    prev: 'Page précédente',
    next: 'Page suivante',
  },
  contact: {
    eyebrow: 'Contactez-nous',
    title: 'Travaillons ensemble',
    first_name: 'Prénom',
    last_name: 'Nom',
    email: 'Adresse e-mail',
    location: 'Lieu',
    subject: 'Objet',
    message: 'Message',
    submit: 'Envoyer',
    sending: 'Envoi…',
  },
  newsletter: {
    title: 'Abonnez-vous à notre lettre d’information',
    text: 'Abonnez-vous et soyez parmi les premiers à recevoir nos nouvelles et des recommandations pour fortifier votre vie spirituelle.',
    eyebrow: 'Restez informé',
    placeholder: 'Votre adresse e-mail',
    subscribe: 'S’abonner',
    sending: 'Envoi…',
    agree: 'En vous abonnant, vous acceptez nos',
    terms: 'Conditions générales',
  },
  footer: {
    tagline: 'Nous sommes la communauté Indabo Za Mariya',
    features: 'Services',
    payment: 'Paiement',
    card: 'Carte',
    transport: 'Transport',
    security: 'Sécurité',
    terms: 'Conditions d’utilisation',
    conditions: 'Conditions',
    privacy: 'Confidentialité',
    copyright: 'Copyright © {year}',
    data_privacy: 'Données et confidentialité',
  },
  booking: {
    title: 'Réserver une place',
    sub_details: 'Saisissez vos coordonnées et ajoutez toutes les personnes qui voyagent avec vous.',
    sub_payment: 'Vérifiez le total et payez en toute sécurité.',
    sub_confirm: 'Presque terminé — confirmation de votre paiement.',
    step_details: 'Coordonnées',
    step_payment: 'Paiement',
    step_confirm: 'Confirmation',
    description: 'Description',
    important: 'Informations importantes',
    departure_time: 'Heure de départ : {time}',
    departure_location: 'Lieu de départ : {place}',
    map_title: 'Carte du lieu de pèlerinage',
    your_details: 'Vos coordonnées',
    your_details_sub: 'Vous êtes le voyageur 1 et la personne de contact pour cette réservation.',
    first_name: 'Prénom',
    last_name: 'Nom',
    first_name_ph: 'Votre prénom',
    last_name_ph: 'Votre nom',
    first_name_short_ph: 'Prénom',
    last_name_short_ph: 'Nom',
    phone: 'Téléphone',
    phone_number: 'Numéro de téléphone',
    email: 'E-mail',
    parish: 'Paroisse',
    parish_ph: 'ex. Sainte Famille',
    gender: 'Sexe',
    female: 'Femme',
    male: 'Homme',
    pickup: 'Lieu de prise en charge',
    optional: 'facultatif',
    member_self: 'Je suis membre de la communauté Indabo za Mariya',
    member_other: 'Membre de la communauté Indabo za Mariya',
    member_tag: 'Membre',
    invalid_phone: 'Saisissez un numéro mobile rwandais valide',
    who: 'Qui voyage ?',
    per_person: '{price} par personne',
    add_traveller: 'Ajouter un autre voyageur',
    add_aria: 'Ajouter un voyageur',
    remove_aria: 'Retirer un voyageur',
    remove_traveller: 'Retirer ce voyageur',
    done: 'Terminé',
    traveller_n: 'Voyageur {n}',
    details_added: 'Informations ajoutées',
    details_needed: 'Informations requises',
    complete_fields: 'Veuillez compléter les champs en surbrillance avant de continuer.',
    travellers: 'Voyageurs',
    summary: 'Récapitulatif',
    transport_line: 'Transport (aller-retour) × {n}',
    fee_line: 'Frais de transaction × {n}',
    total: 'Total',
    people_one: '{n} personne',
    people_other: '{n} personnes',
    payment_method: 'Moyen de paiement',
    card: 'Carte',
    momo_number: 'Numéro Mobile Money',
    momo_note: 'Vous recevrez une demande sur ce téléphone pour approuver {amount} avec votre code PIN.',
    card_note: 'Vous serez redirigé vers la page sécurisée de notre partenaire de paiement pour saisir les informations de votre carte.',
    agree: 'J’accepte les conditions générales de cette opération',
    back: 'Retour',
    next: 'Suivant : paiement',
    processing: 'Traitement…',
    pay: 'Payer {amount}',
    close: 'Fermer',
    reserved_title: 'Votre place est réservée !',
    reserved_text: 'Paiement de {amount} reçu pour {people} — {event}.',
    reference: 'Référence de réservation',
    reference_hint: 'Conservez cette référence ; elle vous sera demandée à l’embarquement.',
    failed_title: 'Paiement non effectué',
    failed_text: 'Le paiement a été refusé, annulé ou a expiré. Aucun montant n’a été prélevé.',
    try_again: 'Réessayer',
    confirming_card: 'Confirmation de votre paiement par carte…',
    approve_phone: 'Approuvez le paiement sur votre téléphone',
    momo_sent: 'Nous avons envoyé une demande Mobile Money de {amount}. Saisissez votre code PIN pour l’approuver. Pas de demande ? Composez {ussd} pour voir les paiements en attente.',
    auto_update: 'Cette page se met à jour automatiquement — ne la fermez pas.',
    not_found: 'Réservation introuvable.',
    timeout: 'Nous n’avons pas encore reçu de confirmation. Si de l’argent a quitté votre compte, contactez-nous avec votre référence de réservation.',
  },
  payment_return: {
    title: 'Votre réservation',
    no_reference: 'Aucune référence de réservation n’a été fournie.',
    home: 'Retour à l’accueil',
  },
};

const rw = {
  lang: { label: 'Ururimi', en: 'English', fr: 'Français', rw: 'Kinyarwanda' },
  nav: {
    home: 'Ahabanza',
    about: 'Abo turi bo',
    pilgrimages: 'Ingendo nyobokamana',
    testimonials: 'Ubuhamya',
    contact: 'Twandikire',
    login: 'Injira',
  },
  banner: {
    open: 'Kwiyandikisha birakomeje: {name}, {date}.',
    closed: 'Urugendo nyobokamana rutaha: {name}, {date}.',
    fallback: 'Ngwino twifatanye mu rugendo nyobokamana rukorwa ku cyumweru cya nyuma cya buri kwezi.',
    reserve: 'Iyandikishe nonaha!',
    booking_closed: 'Kwiyandikisha byarangiye',
  },
  hero: {
    eyebrow: 'Indabo Za Mariya',
    title: 'Murakaza neza mu muryango w’Indabo za Mariya',
    subtitle: 'Aho waba ugeze hose mu rugendo rwawe, wakiriwe neza hano. Waba ushaka ibisubizo cyangwa umuryango wo kubamo, turagutumira ngo twifatanye.',
    cta: 'Reba ingendo nyobokamana',
    image_alt: 'Ishusho ya Bikira Mariya yambaye umwitero w’ubururu, asenga afite ishapule',
  },
  about: {
    eyebrow: 'Ibyerekeye Indabo za Mariya',
    title: 'Abo turi bo',
    intro: 'Umuryango Gatolika “Indabo za Mariya Nyina wa Jambo wa Kibeho Umwamikazi w’Imitima” washinzwe nyuma y’igitekerezo umukirisitukazi yahumekewemo n’Imana mu gitambo cya Misa nkuru ya Noheli, ku itariki ya 25 Ukuboza 2004, muri Paruwasi Katedrali ya Mutagatifu Mikayile (Saint Michel), muri Arikidiyosezi ya Kigali.',
    welcome: 'Murakaza neza mu Ndabo za Mariya',
    mission: 'Ushingiye ku butumwa bwa Bikira Mariya w’i Kibeho, uyu muryango washinzwe kugira ngo ufashe abakirisitu kuvugurura ukwemera kwabo, kurushaho kugirana ubucuti n’Imana, no kubaho bakurikiza inyigisho za Kiliziya Gatolika. Umuryango uteza imbere isengesho, ivugabutumwa, imyiherero, n’ingendo nyobokamana zijya i Kibeho buri cyumweru cya nyuma cy’ukwezi.',
    photo_back_alt: 'Abanyamuryango b’Indabo za Mariya bambaye imyenda yera n’ibitambaro by’ubururu, bateraniye imbere ya kiliziya',
    photo_front_alt: 'Abanyamuryango bafashe buji mu gitambo cya Misa hamwe na padiri',
  },
  pilgrimages: {
    title: 'Ingendo nyobokamana ziteganyijwe',
    loading: 'Turimo gushaka ingendo nyobokamana ziteganyijwe…',
    closes: 'Kwiyandikisha birangira {when}',
    closed: 'Kwiyandikisha byarangiye',
    reserve: 'Iyandikishe',
    opens_soon: 'Kwiyandikisha biratangira vuba',
    more: 'Izindi ngendo nyobokamana',
    showcase: {
      kibeho: 'Tugufasha kurushaho kwegera Imana tuguha inyigisho, ubujyanama n’umuryango ugushyigikira. Intego yacu ni ugufasha buri wese gukora ingendo nyobokamana zifite icyo zisobanuye, kubona amahoro yo mu mutima, no gushinga imizi mu kwemera kwe.',
      sinai: 'Ngwino tujyane mu rugendo ruhindura ubuzima, tuzamuke umusozi aho amateka n’ukwemera bihurira. Uzabona ahantu heza cyane, inzira za kera, n’ibihe byo kwitekerezaho by’ukuri.',
      camino: 'Genda inzira y’urugendo nyobokamana yamamaye, unyure mu misozi myiza no mu mico itandukanye. Abayobozi bacu b’inararibonye bazakwitaho ku buryo urugendo ruzaba urw’umutekano, rugutera imbaraga kandi rutazibagirana.',
    },
  },
  moments: {
    eyebrow: 'Urugendo nyobokamana twakoze',
    title: 'Urugendo nyobokamana rwacu muri Tanzaniya',
    tag: 'Tanzaniya',
    p1: 'Abagenzi b’Indabo za Mariya twajyanye muri Tanzaniya, twakirwa n’umuryango w’Indabo za Mariya waho. Twambaye imyenda yera n’ibitambaro byacu by’ubururu, twarasenze, turaririmba kandi dutura Igitambo cya Misa nk’umuryango umwe, turi mu maboko ya Bikira Mariya.',
    p2: 'Ibihe nk’ibi bitwibutsa ko ukwemera kwacu kutagira imipaka, kandi ko buri rugendo nyobokamana rutwegereza Mariya, rukanatwegeranya twese.',
    cta: 'Ifatanye natwe mu rugendo rutaha',
    gallery: 'Ibihe byiza mu muryango wacu',
    feature_alt: 'Umuryango w’Indabo za Mariya, wambaye imyenda yera n’ibitambaro by’ubururu, uteraniye imbere ya kiliziya muri Tanzaniya',
    praise: 'Gusingiza no kuramya',
    praise_alt: 'Abanyamuryango bazamuye amaboko basingiza Imana mu Misa',
    vigil: 'Isengesho ducanye buji',
    vigil_alt: 'Abasore bafashe buji zaka mu birori',
    offering: 'Ituro kuri Mariya',
    offering_alt: 'Umunyamuryango wambaye umweru afashe ururabo rw’umuhondo',
    youth: 'Urubyiruko mu isengesho',
    youth_alt: 'Urubyiruko rw’umuryango rusenga rurambuye amaboko',
  },
  testimonials: {
    eyebrow: 'Ubuhamya',
    title: 'Uko ubuzima buhindurwa n’urukundo n’ukwemera.',
    play: 'Kina videwo y’ubuhamya',
    poster_alt: 'Urubyiruko rw’umuryango rusenga mu Misa',
    pages: 'Amapaji y’ubuhamya',
    prev: 'Ipaji ibanza',
    next: 'Ipaji ikurikira',
  },
  contact: {
    eyebrow: 'Twandikire',
    title: 'Dufatanye',
    first_name: 'Izina ribanza',
    last_name: 'Izina ry’umuryango',
    email: 'Imeyili',
    location: 'Aho uherereye',
    subject: 'Impamvu',
    message: 'Ubutumwa',
    submit: 'Ohereza',
    sending: 'Biroherezwa…',
  },
  newsletter: {
    title: 'Iyandikishe ku makuru yacu',
    text: 'Iyandikishe kugira ngo ujye ubona mbere y’abandi amakuru mashya n’inama zagufasha gukomeza ubuzima bwawe bwa roho.',
    eyebrow: 'Komeza kumenya amakuru',
    placeholder: 'Andika imeyili yawe',
    subscribe: 'Iyandikishe',
    sending: 'Biroherezwa…',
    agree: 'Mu kwiyandikisha, wemera',
    terms: 'Amategeko n’amabwiriza',
  },
  footer: {
    tagline: 'Turi umuryango w’Indabo za Mariya',
    features: 'Serivisi',
    payment: 'Kwishyura',
    card: 'Ikarita',
    transport: 'Ubwikorezi',
    security: 'Umutekano',
    terms: 'Amategeko',
    conditions: 'Amabwiriza',
    privacy: 'Ibanga ry’amakuru',
    copyright: 'Uburenganzira bwose © {year}',
    data_privacy: 'Amakuru n’ibanga',
  },
  booking: {
    title: 'Kwiyandikisha',
    sub_details: 'Uzuza amakuru yawe kandi wongeremo abo muzajyana bose.',
    sub_payment: 'Reba igiteranyo maze wishyure mu mutekano.',
    sub_confirm: 'Hasigaye gato — turimo kwemeza ubwishyu bwawe.',
    step_details: 'Amakuru',
    step_payment: 'Kwishyura',
    step_confirm: 'Kwemeza',
    description: 'Ibisobanuro',
    important: 'Amakuru y’ingenzi',
    departure_time: 'Isaha yo guhaguruka: {time}',
    departure_location: 'Aho duhagurukira: {place}',
    map_title: 'Ikarita y’aho urugendo nyobokamana ruzabera',
    your_details: 'Amakuru yawe',
    your_details_sub: 'Ni wowe mugenzi wa mbere, kandi ni wowe tuzavugana ku bijyanye n’iri yandikisha.',
    first_name: 'Izina ribanza',
    last_name: 'Izina ry’umuryango',
    first_name_ph: 'Andika izina ribanza',
    last_name_ph: 'Andika izina ry’umuryango',
    first_name_short_ph: 'Izina ribanza',
    last_name_short_ph: 'Izina ry’umuryango',
    phone: 'Telefoni',
    phone_number: 'Nimero ya telefoni',
    email: 'Imeyili',
    parish: 'Paruwasi',
    parish_ph: 'urugero: Sainte Famille',
    gender: 'Igitsina',
    female: 'Gore',
    male: 'Gabo',
    pickup: 'Aho uzurira imodoka',
    optional: 'si ngombwa',
    member_self: 'Ndi umunyamuryango w’Indabo za Mariya',
    member_other: 'Ni umunyamuryango w’Indabo za Mariya',
    member_tag: 'Umunyamuryango',
    invalid_phone: 'Andika nimero ya telefoni igendanwa yo mu Rwanda yemewe',
    who: 'Ni bande bazajya mu rugendo?',
    per_person: '{price} ku muntu',
    add_traveller: 'Ongeraho undi mugenzi',
    add_aria: 'Ongeraho umugenzi',
    remove_aria: 'Kuramo umugenzi',
    remove_traveller: 'Kuramo uyu mugenzi',
    done: 'Ndangije',
    traveller_n: 'Umugenzi wa {n}',
    details_added: 'Amakuru yuzuye',
    details_needed: 'Amakuru arakenewe',
    complete_fields: 'Banza wuzuze ahagaragajwe mbere yo gukomeza.',
    travellers: 'Abagenzi',
    summary: 'Incamake y’ikiguzi',
    transport_line: 'Urugendo (kugenda no kugaruka) × {n}',
    fee_line: 'Amafaranga ya serivisi × {n}',
    total: 'Igiteranyo',
    people_one: 'umuntu {n}',
    people_other: 'abantu {n}',
    payment_method: 'Uburyo bwo kwishyura',
    card: 'Ikarita',
    momo_number: 'Nimero ya Mobile Money',
    momo_note: 'Uzakira ubutumwa kuri iyi telefoni bugusaba kwemeza {amount} ukoresheje umubare w’ibanga (PIN).',
    card_note: 'Uzoherezwa ku rubuga rwizewe rw’umufatanyabikorwa wacu mu by’ubwishyu kugira ngo wuzuze amakuru y’ikarita yawe.',
    agree: 'Nemeye amategeko n’amabwiriza agenga iki gikorwa',
    back: 'Subira inyuma',
    next: 'Komeza: kwishyura',
    processing: 'Birimo gukorwa…',
    pay: 'Ishyura {amount}',
    close: 'Funga',
    reserved_title: 'Umwanya wawe urabitswe!',
    reserved_text: 'Twakiriye ubwishyu bwa {amount} ku {people} — {event}.',
    reference: 'Nimero y’iyandikisha',
    reference_hint: 'Bika iyi nimero; uzayisabwa igihe cyo kurira imodoka.',
    failed_title: 'Ubwishyu ntibwarangiye',
    failed_text: 'Ubwishyu bwanzwe, bwahagaritswe cyangwa igihe cyabwo cyarenze. Nta mafaranga wakuweho.',
    try_again: 'Ongera ugerageze',
    confirming_card: 'Turimo kwemeza ubwishyu bw’ikarita yawe…',
    approve_phone: 'Emeza ubwishyu kuri telefoni yawe',
    momo_sent: 'Twohereje ubusabe bwa Mobile Money bwa {amount}. Andika umubare w’ibanga (PIN) kugira ngo ubwemeze. Nta butumwa wabonye? Kanda {ussd} urebe ubwishyu butegereje.',
    auto_update: 'Iyi paji yivugurura ubwayo — ntuyifunge.',
    not_found: 'Ntitwabonye iri yandikisha.',
    timeout: 'Ntiturabona icyemezo. Niba amafaranga yavuye kuri konti yawe, twandikire uduhe nimero y’iyandikisha.',
  },
  payment_return: {
    title: 'Iyandikisha ryawe',
    no_reference: 'Nta nimero y’iyandikisha yatanzwe.',
    home: 'Subira ahabanza',
  },
};

export const TRANSLATIONS = { en, fr, rw };
export const LANGUAGES = ['en', 'fr', 'rw'];
